import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { message, Button, Result } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';

export default function Fail() {
  const navigate = useNavigate();

  useEffect(() => {
    message.error("Subscription failed. Please try again.");
  }, []);

  return (
    <Result
      icon={<CloseCircleOutlined style={{ color: 'red' }} />}
      title="Subscription Failed"
      subTitle="There was an issue with your subscription. Please try again."
      extra={
        <Button type="primary" onClick={() => navigate('/leads')}>
          Go to Dashboard
        </Button>
      }
    />
  );
}
